import { chatFragment, chatSubscriptionFragment } from '../fragments';
import { store } from '../../store';
import { subscribe } from '../utils';

export const subscribeToChatCreating = async () => {
  const stream = await subscribe({
    operationName: 'ChatCreated',
    query: `
      subscription ChatCreated {
        chatCreated {
          ...ChatFragment
        }
      }

      ${chatFragment}
    `,
  });

  for await (const event of stream) {
    const data = event.data?.chatCreated;
    if (data) {
      store.dispatch('chat/addToList', data);
    }
  }
};

export const subscribeToChatUpdating = async () => {
  const stream = await subscribe({
    operationName: 'ChatUpdated',
    query: `
      subscription ChatUpdated {
        chatUpdated {
          ...ChatFragment
        }
      }

      ${chatFragment}
    `,
  });

  for await (const event of stream) {
    const data = event.data?.chatUpdated;
    if (data) {
      store.dispatch('chat/updateInList', data);
    }
  }
};

export const subscribeToChatDeleting = async () => {
  const stream = await subscribe({
    operationName: 'ChatDeleted',
    query: `
      subscription ChatDeleted {
        chatDeleted {
          ...ChatFragment
        }
      }

      ${chatFragment}
    `,
  });

  for await (const event of stream) {
    const data = event.data?.chatDeleted;
    if (data) {
      store.dispatch('chat/removeFromList', data.id);
    }
  }
};
